import { render, staticRenderFns } from "./GeneralSettingsCurrency.vue?vue&type=template&id=0178473d&"
import script from "./GeneralSettingsCurrency.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports